import axios from "axios";
export const BACKEND_URL = "https://efc.cv19.app:8777/creator/"
// export const BACKEND_URL = "http://127.0.0.1:5000/"

// export const URL = BACKEND_URL + "/app"
// export const request = (callBAck) => {

//     try {
//         store.state.config.loading = true
//         axios
//             .post(BACKEND_URL + "/calendarcv02/get_configurations")
//             .then(function (response) {
//                 const jsonS = response.data;
//                 var temp_config = {}
//                 jsonS.forEach(element => {
//                     temp_config[element.item_name] = element.item_value
//                 });
//                 store.dispatch("fetchConfig", temp_config);
//                 console.log(jsonS);
//                 if (callBAck) callBAck()
//             })

//         // const response = await fetch('https://stag.cv19.app:8449', {
//         //     method: 'post'
//         // });
//         // const jsonS = await response.json();
//         // var temp_config = {}
//         // jsonS.forEach(element => {
//         //     temp_config[element.item_name] = element.item_value
//         // });
//         // store.dispatch("fetchConfig", temp_config);
//         // debugger
//         // console.log(jsonS);
//         // if (callBAck) callBAck()
//     }
//     catch (e) {
//         console.log('We have the error', e);
//     }
// }
export const FORM_ID = "3"
// export const FORM_ID_PDF = "3"
// export const HOUSE_HOLD_NUMBERLHPED = "10"
// export const HOUSE_HOLD_NUMBER = "3"
// export const HOURS_LIMIT = 24
// export const YEARS = 18
// export const EMAIL_TO = "lhcv19app@gmail.com"
// export const EMAIL_TO_STAGE = "rashmi@ensofia.com"
// export const MESSAGE = "When you arrive to your appointment, please remain in the car and call us, and we will let you know when to come in. Keep a mask on at all times, and we will open and close the doors for you, Thank you. From Lighthouse pediatrics"
// export const MESSAGE_ARABIC = "عندما تصل إلى موعدك ، يرجى البقاء في السيارة والاتصال بنا ، وسنخبرك بموعد دخولك. احتفظ بقناع في جميع الأوقات ، وسنفتح لك الأبواب ونغلقها ، شكرًا لك. من طب الأطفال المنارة"



// export const URL_PRODUCTION = "https://lhpeds.cv19.app:8451/app"
// export const URL_STAGE = "https://stag.cv19.app:8449/app"
// export const URL_LOCAL = "http://127.0.0.1:5000"
export const URL = "https://efc.cv19.app:8777/creator"
// export const URL_LHPEDS="https://lhpeds.cv19.app:8451/app"
// https://lhpeds.cv19.app:8451
// cv19: 5432
// stag:5433
// lhpeds:5434  


// WEBPACK FOOTER //
// ./src/variables.js